import { PlayerPoints } from '../../database.schema';

type CaptainsPoints = {
  position: number;
  points: number;
};
const getCaptainPoints = (numberOfPlayers: number): CaptainsPoints[] => {
  const captainPoints = [];
  let index = 0;
  for (index; index < numberOfPlayers; index++) {
    captainPoints.push({ position: index + 1, points: numberOfPlayers - index });
  }
  return captainPoints;
};

export const calculatePositions = (playerResults: Array<PlayerPoints>, key: keyof PlayerPoints): Array<PlayerPoints> => {
  let position = 1;
  const sortedPlayers = playerResults.sort((a: PlayerPoints, b: PlayerPoints) => (b[key] as number) - (a[key] as number));
  return sortedPlayers.map((player: PlayerPoints, index: number): PlayerPoints => {
    if (index === 0) {
      return { ...player, position };
    }
    if (playerResults[index - 1][key] === player[key]) {
      return { ...player, position };
    } else {
      position = index + 1;
      return { ...player, position };
    }
  });
};

const getAggregatePoints = (pointsToAggregagte: number, fromIndex: number, captainPoints: CaptainsPoints[]) => {
  const pointsToAggregateArray = captainPoints.slice(fromIndex, fromIndex + pointsToAggregagte);
  const accumulatedPoints = pointsToAggregateArray.reduce((acc, current) => (acc += current.points), 0);
  return accumulatedPoints / pointsToAggregagte;
};

export const calculateCaptainPoints = (playerResults: Array<PlayerPoints>, numberOfPlayers: number): Array<PlayerPoints> => {
  const captainPoints = getCaptainPoints(numberOfPlayers);
  let returnPlayerResults: Array<PlayerPoints> = [];
  const playerResultsWithPosition = calculatePositions(playerResults, 'points');

  captainPoints.forEach((positionPoint, index) => {
    const playerResultsInPosition: Array<PlayerPoints> = playerResultsWithPosition.filter((playerResult: PlayerPoints) => playerResult.position === positionPoint.position);

    if (playerResultsInPosition.length > 1) {
      const aggregatePoints = getAggregatePoints(playerResultsInPosition.length, index, captainPoints);
      const newSet = playerResultsInPosition.map(
        (playerResult: PlayerPoints): PlayerPoints => ({ ...playerResult, captainPoints: (playerResult.captainPoints += aggregatePoints) })
      );
      returnPlayerResults = [...returnPlayerResults, ...newSet];
    }
    if (playerResultsInPosition.length === 1) {
      playerResultsInPosition[0].captainPoints += positionPoint.points;
      return [...returnPlayerResults, ...playerResultsInPosition];
    }
  });
  return calculatePositions(
    playerResultsWithPosition.sort((a: PlayerPoints, b: PlayerPoints) => b.captainPoints - a.captainPoints),
    'captainPoints'
  );
};
